import React from 'react';
import ReactDOM from 'react-dom';
import './Loading.scss'


const Modal = ({isShowing}) => isShowing ? ReactDOM.createPortal(
    <React.Fragment>
        <div className="loading-modal-overlay fixed top-0 left-0 w-screen h-screen opacity-50"/>
        <div className={`loading-modal-wrapper fixed top-0 left-0 w-full h-full flex flex-col items-center justify-center`}
             aria-modal aria-hidden tabIndex={-1} role="dialog">
            <div className={`loading-modal relative bg-none w-fit h-fit`}>
                <div className={"loader"} />
            </div>
        </div>
    </React.Fragment>, document.body
) : null;

export default Modal;
